import { Validation } from '../../sceneDataSchema';
import { z } from 'zod';
import { ValidationType } from '@/constants/validationTypes';

const brokenValidations = [ValidationType.AllowedValues, ValidationType.NotAllowedValues];

export function numberValidator(validations: Validation[]) {
  const schema = validations.reduce(
    (schema, validation) => {
      switch (validation.type) {
        case ValidationType.Min:
          if (typeof validation.value == 'string') {
            return schema;
          }

          return schema.min(validation.value, `Must be at least ${validation.value}`);
        case ValidationType.Max:
          if (typeof validation.value == 'string' || validation.value === null) {
            return schema;
          }
          return schema.max(validation.value, `Must be at most ${validation.value}`);
        default:
          return schema;
      }
    },
    z.number({ message: 'this field is required' })
  );

  validations
    .filter((validation) => brokenValidations.includes(validation.type))
    .forEach((validation) => {
      console.error('Attempting to use a broken validation on a number', validation);
    });

  let required = false;

  const refinedSchema = validations.reduce((schema, validation) => {
    switch (validation.type) {
      // TODO: Update the following validations to work on numbers.
      case ValidationType.NotAllowedValues:
        return schema.refine(
          (val) => !validation.value.includes(val),
          `Cannot be one of: ${validation.value.join(', ')}`
        );
      case ValidationType.AllowedValues:
        return schema.refine((val) => validation.value.includes(val), `Must be one of: ${validation.value.join(', ')}`);
      case ValidationType.Required:
        required = true;
        return schema;
      default:
        return schema;
    }
  }, schema);

  if (required) {
    return refinedSchema;
  }

  return refinedSchema.nullable();
}
